import { render, staticRenderFns } from "./AddStore.vue?vue&type=template&id=226e4d75&scoped=true&"
import script from "./AddStore.vue?vue&type=script&lang=ts&"
export * from "./AddStore.vue?vue&type=script&lang=ts&"
import style0 from "./AddStore.vue?vue&type=style&index=0&id=226e4d75&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226e4d75",
  null
  
)

export default component.exports